import { render, staticRenderFns } from "./AddFromMdokModal.vue?vue&type=template&id=b57f3e08&"
import script from "./AddFromMdokModal.vue?vue&type=script&lang=js&"
export * from "./AddFromMdokModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports